import getByIdPropWorkoutSectionSelect from '../get-by-id-prop'

function getByIdWorkoutSectionSelector (id) {
  return (state) => getByIdPropWorkoutSectionSelect(state, { id })
}

export default getByIdWorkoutSectionSelector
